document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initContadores();
  initCountdown();
  initMlc();
  initEmailPopup();
});

function initEmailPopup() {
  const overlay = document.querySelector('[data-mt-popup-overlay]');
  if (!overlay) return;

  const STORAGE_KEY = 'mt_popup_dismissed';
  const wasSubmitted = !!overlay.querySelector('[data-mt-popup-success]');

  const openPopup = () => {
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('mt-popup-visible'));
  };
  const closePopup = () => {
    overlay.classList.remove('mt-popup-visible');
    window.localStorage.setItem(STORAGE_KEY, '1');
    setTimeout(() => { overlay.hidden = true; }, 250);
  };

  overlay.querySelectorAll('[data-mt-popup-close]').forEach((btn) => {
    btn.addEventListener('click', closePopup);
  });
  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closePopup();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !overlay.hidden) closePopup();
  });

  if (wasSubmitted) {
    window.localStorage.setItem(STORAGE_KEY, '1');
    openPopup();
    return;
  }

  if (window.localStorage.getItem(STORAGE_KEY) === '1') return;

  setTimeout(openPopup, 6000);
}

function initMlc() {
  const root = document.querySelector('[data-mt-mlc]');
  if (!root) return;

  const trigger = root.querySelector('[data-mt-mlc-trigger]');
  const list = root.querySelector('[data-mt-mlc-list]');
  const form = document.getElementById('MtMlcForm');
  const localeInput = document.getElementById('MtMlcLocale');
  const countryInput = document.getElementById('MtMlcCountry');

  const closeList = () => {
    list.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  };

  trigger.addEventListener('click', () => {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closeList();
    } else {
      list.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
  });

  root.querySelectorAll('[data-mt-mlc-currency]').forEach((option) => {
    option.addEventListener('click', () => {
      localeInput.value = root.dataset.currentLocale;
      countryInput.value = option.dataset.country;
      form.submit();
    });
  });

  root.querySelectorAll('[data-mt-mlc-language]').forEach((option) => {
    option.addEventListener('click', () => {
      localeInput.value = option.dataset.locale;
      countryInput.value = root.dataset.currentCountry;
      form.submit();
    });
  });

  document.addEventListener('click', (event) => {
    if (!root.contains(event.target)) closeList();
  });
}

function initCountdown() {
  const barras = document.querySelectorAll('[data-mt-countdown-semanal]');
  if (!barras.length) return;

  const formatear = (segundosTotales) => {
    const dias = Math.floor(segundosTotales / 86400);
    const h = Math.floor((segundosTotales % 86400) / 3600);
    const m = Math.floor((segundosTotales % 3600) / 60);
    const s = segundosTotales % 60;
    const hms = [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
    return dias > 0 ? `${dias}d ${hms}` : hms;
  };

  // Cuenta hacia el próximo domingo a las 23:59:59 (hora local del visitante).
  // Al pasar la medianoche del lunes, este cálculo arranca solo una cuenta
  // nueva de ~7 días: el contador se renueva cada semana sin intervención.
  const segundosHastaFinDeSemana = () => {
    const ahora = new Date();
    const finSemana = new Date(ahora);
    const diasHastaDomingo = (7 - ahora.getDay()) % 7;
    finSemana.setDate(ahora.getDate() + diasHastaDomingo);
    finSemana.setHours(23, 59, 59, 999);
    if (finSemana <= ahora) {
      finSemana.setDate(finSemana.getDate() + 7);
    }
    return Math.max(0, Math.floor((finSemana - ahora) / 1000));
  };

  barras.forEach((barra) => {
    const timeEl = barra.querySelector('[data-mt-countdown-time]');
    if (!timeEl) return;
    let restante = segundosHastaFinDeSemana();
    timeEl.textContent = formatear(restante);

    setInterval(() => {
      restante -= 1;
      if (restante <= 0) restante = segundosHastaFinDeSemana();
      timeEl.textContent = formatear(restante);
    }, 1000);
  });
}

function initReveal() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.01, rootMargin: '0px 0px 120px 0px' }
  );

  els.forEach((el, i) => {
    if (!el.style.getPropertyValue('--mt-delay')) {
      const group = el.closest('[data-mt-stagger]');
      if (group) {
        const siblings = Array.from(group.querySelectorAll('.mt-reveal'));
        const index = siblings.indexOf(el);
        el.style.setProperty('--mt-delay', `${Math.min(index * 50, 200)}ms`);
      }
    }
    observer.observe(el);
  });
}

function initContadores() {
  const els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;

  const animar = (el) => {
    const target = parseFloat(el.dataset.mtContador || '0');
    const prefijo = el.dataset.mtPrefijo || '';
    const sufijo = el.dataset.mtSufijo || '';
    const decimales = el.dataset.mtDecimal === 'true' ? 1 : 0;
    const duracion = 1400;
    const inicio = performance.now();
    const formatear = (valor) =>
      prefijo + valor.toLocaleString('es-ES', { minimumFractionDigits: decimales, maximumFractionDigits: decimales }) + sufijo;
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      el.textContent = formatear(target);
      return;
    }
    function paso(ahora) {
      const progreso = Math.min((ahora - inicio) / duracion, 1);
      const ease = 1 - Math.pow(1 - progreso, 3);
      el.textContent = formatear(target * ease);
      if (progreso < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  };

  if (!('IntersectionObserver' in window)) {
    els.forEach(animar);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animar(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );
  els.forEach((el) => observer.observe(el));
}
